import { Flex, Heading } from '@chakra-ui/react'
import React from 'react'
import AnimatedPage from '../components/Other/AnimatedPage'

const NotFound = () => {
  return (
    <AnimatedPage>
      <Flex minH={'66vh'} mb={'2rem'} mt={'4rem'} justifyContent={'center'} alignItems={'center'}>
        <Heading>Page doesnt exist</Heading>
      </Flex>
      </AnimatedPage>
  )
}

export default NotFound;